<template>
    <CCard>      
        <CCardBody>
            <CRow>        
                <div class="col-lg-12 control-section">
                    <div class="content-wrapper">
                      <div id="app">
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='grid' locale='zh-TW' :dataSource='this.datas' :childGrid='this.childdatas' height='500' :allowExcelExport='true'
                                :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :toolbar='toolbar' 
                                :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                                :load='load' :toolbarClick="toolbarClick" :rowSelected='rowSelected' :recordDoubleClick="pubDoubleClick"  >
                                <e-columns>
                                    <e-column field='date' headerText='生產日期' aria-required="true" :isPrimaryKey='true' width='130'></e-column>              
                                    <e-column field='name' headerText='產品品名' width='250'></e-column>
                                    <e-column field='manager' headerText='生產組組長' width='80' :template="managerTemplate"></e-column>
                                    <e-column field='monitor' headerText='班長' width='80' :template="monitorTemplate"></e-column>                           
                                    <e-column field='report' headerText='外包裝檢點表' width='80' :template="urlTemplate" :allowFiltering='false'></e-column>
                                </e-columns>
                            </ejs-grid>        
                        </ejs-tooltip>
                      </div>                  
                    </div>                      
                </div>  
            </CRow>
        </CCardBody>
        <div class="control-section">
            <ejs-dialog ref="dialogSign" showCloseIcon='true' isModal='true' :visible='false' header='簽名' width='60%' closeOnEscape='true' >
                <SignTemplate ref="mySignTemplate" v-on:onSignClose="onSignTemplateItem"></SignTemplate>
            </ejs-dialog>
        </div>   
    </CCard>
  </template>
  
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script>
  
    import Vue from "vue";
    import { L10n, enableRipple  } from '@syncfusion/ej2-base';
    import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
    import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { GridComponent, ColumnsDirective, ColumnDirective, GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
    import SignTemplate from "./compone/Sign.vue";
    import zhtwLocalization  from '../language/language.json';

    L10n.load(zhtwLocalization);

  
    enableRipple(true);
    Vue.use(DialogPlugin);
    Vue.use(GridPlugin);    
    Vue.use(ButtonPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(NumericTextBoxPlugin );
    Vue.use(RadioButtonPlugin);
    Vue.use(TooltipPlugin);
    Vue.prototype.$eventHub = new Vue(); 
    export default Vue.extend({     
        components: {
          'ejs-grid': GridComponent,
          'e-columns': ColumnsDirective,
          'e-column': ColumnDirective,
          SignTemplate
        },
        data: function() {
          return {
  
              datas : [
                { 'date' : '2025-01-01', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '' , 'chk_s_operator': '小小明', 'add_operator' : '', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-02', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' ,  'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-03', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' ,  'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-04', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' ,  'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-05', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-06', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'},  
                { 'date' : '2025-01-07', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'},  
                { 'date' : '2025-01-08', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-09', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'},  
                { 'date' : '2025-01-10', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-11', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-12', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-13', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-14', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
                { 'date' : '2025-01-15', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'wei_s_operator' : '小小明' , 'chk_s_operator': '小小明', 'add_operator' : '小小明', 'chk_operator' : 'A', 'chk_user' : 'B', 'write_user' : 'C' , 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/OutPackage?no=1&token=2'}, 
              ],
              pageSettings:  {pageSize: 10, pageSizes: [10,50,100,200], pageCount: 10 },     
              toolbar: [{ text: '匯出Excel', tooltipText: '匯出Excel', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' },'Search'],     
              filterSettings: { type: 'Excel' },
              selectionSettings: { persistSelection: true },
              animationSettings: { effect: 'Fade' },
              visible : false,
  
              childdatas: {
                  dataSource: [ 
                      { 'date' : '2025-01-01', 'no' : '1', 'name' : '蘋果' },
                      { 'date' : '2025-01-01', 'no' : '2', 'name' : '梅子' },
                      { 'date' : '2025-01-01', 'no' : '3', 'name' : '蜂蜜蘋果' },
                      { 'date' : '2025-01-01', 'no' : '4', 'name' : '桑葚' }                  
                  ],
                  queryString: "date",
                  allowPaging: false,                
                  columns: [      
                      { field: "no",   headerText: "序號", width: 80 },  
                      { field: "time",   headerText: "時間", width: 80 },  
                      { field: "name", headerText: "品名", width: 120 },
                      { field: "capacity", headerText: "內容量", width: 120 },
                      { field: "count", headerText: "數量", width: 120 },
                      { field: "color", headerText: "色澤", width: 120 },  
                      { field: "bastatus", headerText: "貼標狀況", width: 120 },  
                      { field: "foreign", headerText: "雜異物", width: 120 },  
                      { field: "hdate", headerText: "瓶標日期", width: 120 },  
                      { field: "pdate", headerText: "紙箱日期", width: 120 },  
                      { field: "cdate", headerText: "清晰度", width: 120 },  
                      { field: "pp", headerText: "條碼", width: 120 },  
                      { field: "monitor", headerText: "檢點人員", width: 120 }                  
                  ],
              },
              managerTemplate: function () {
                return {
                    template: Vue.component('managerTemplate', {
                        template: `<div id="coordinates">
                                <span id="locationtext">{{data.manager}}<a @click="doSomething" href="#"><img src="img/icon/pen.png" class="e-image" width="20px"/></a></span>        
                                </div>`,
                        data: function () { return { data: {} }; },
                        computed: { }, 
                          methods: {
                            doSomething(e) {
                                this.$eventHub.$emit('sign',e);                               
                            }                          
                          }
                    })
                }
              },
              monitorTemplate: function () {
                return {
                    template: Vue.component('monitorTemplate', {
                        template: `<div id="coordinates">
                                <span id="locationtext">{{data.monitor}}<a @click="doSomething" href="#"><img src="img/icon/pen.png" class="e-image" width="20px"/></a></span>        
                                </div>`,
                        data: function () { return { data: {} }; },
                        computed: { }, 
                          methods: {
                            doSomething(e) {
                                this.$eventHub.$emit('sign',e);                               
                            }                          
                          }
                    })
                }
              },           
              urlTemplate: function () {
                  return {
                      template: Vue.component('yesnoTemplate', {
                          template: `<div id="coordinates">
                                  <span id="locationtext"><a target="_blank" :href="data.report"><img src="img/icon/report.png" class="e-image" width="30px" :alt="data.report"/></a></span>        
                                  </div>`,
                          data: function () { return { data: {} }; },
                          computed: { }
                      })
                  }
              }         
        };
    },         
    mounted: function(){
        
    },
    methods: {           
        beforeRender: function (args) {
            if (args.target.closest("td")) {
                this.$refs.tooltip.content = args.target.innerText;                
            }
        },   
        pubDoubleClick: function () {  
            
        },
        editOkClick: function () {           
            this.upData();         
        },
        valueChange: function () {  
            this.isDataChanged = true;
            this.stTime = null;
        },
        load: function() {   
  
        },       
        addAction: function() {
  
        },      
        toolbarClick: function(args) {
          if (args.item.id == "Export") {
              this.$refs.grid.excelExport();
          }
        },   
  
        actionComplete: function() {                             
        },
        rowSelected: function() {          
        },    
        showError: function(error) {
            if (error.response.status == 400) {
                for(var key in error.response.data.errors){                 
                    this.$toast.open({message: error.response.data.errors[key][0] , type: "warning", duration: 5000, dismissible: true}) 
                }
                return;
            }    
            if (error.response.status == 401) {  
                localStorage.removeItem('token'); this.$router.push('/login'); 
                return; 
            }                
            this.$toast.open({message: '系統發生錯誤' + error.response.status, type: "error", duration: 5000, dismissible: true}) 
        }
    },
    created() {        
        this.$eventHub.$on('sign', ()=>{ 
            this.$refs.dialogSign.show();
      }); 
    },
    beforeDestroy() {
        this.$eventHub.$off('sign');
    },
    computed: {
    },
  
    provide: {
        grid: [PdfExport, ExcelExport, Sort , DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]      
    }
    });
  </script>
  
  <style scoped>
      @import "../../scss/grid.scss"
  </style>